"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var resourcePreloader_service_1 = require("./resourcePreloader.service");
var Module = window.Module;
var ToolService = (function () {
    function ToolService(resourcePreloaderService) {
        this.resourcePreloaderService = resourcePreloaderService;
        this.loadTools();
    }
    ToolService.prototype.loadTools = function () {
        if (this.areToolsLoaded) {
            return this.areToolsLoaded;
        }
        this.areToolsLoaded = Module.GToolManager.sharedInstance().loadToolsFromFileContent(this.resourcePreloaderService.toolInfos);
        return this.areToolsLoaded;
    };
    ToolService.prototype.allToolTypes = function () {
        var vector = Module.GToolManager.sharedInstance().getAllToolTypes();
        var res = [];
        for (var i = 0, len = vector.size(); i < len; i++) {
            res.push(vector.get(i));
        }
        return res;
    };
    ToolService.prototype.toolInfoWithType = function (toolType) {
        var toolInfo = Module.GToolManager.sharedInstance().getToolInfo(toolType);
        toolInfo.icon = toolType + ".svg";
        return toolInfo;
    };
    return ToolService;
}());
ToolService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [resourcePreloader_service_1.ResourcePreloaderService])
], ToolService);
exports.ToolService = ToolService;



//////////////////
// WEBPACK FOOTER
// ./src/services/tool.service.ts
// module id = 147
// module chunks = 0